var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header-bar"},[_c('img',{staticClass:"logo-pic",attrs:{"src":_vm.logoPic}}),(_vm.isRule)?_c('div',{staticClass:"rule-txt",on:{"click":function($event){return _vm.$emit('link')}}},[_vm._v(_vm._s(_vm.ruleTxt || _vm.$t('activity.activityRule')))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }